<template>
  <div class="empresarial container mt-0 mt-lg-4 mb-lg-5 mb-0 md-elevation-6">
    <div class="front row">
      <div class="row">
        <div class="d-flex align-items-center sombra-container container">
          <div class="col-4">
            <img src="../assets/icon/global_man_750_white.png" class="w-100" alt="">
          </div>
          <div class="col-8">
            <h2 class="m-0 md-display-1 text-white text-uppercase d-none d-lg-inline-block font-weight-bolder">
              Conheça nossos serviços empresariais e aumente a
              produtividade da sua equipe.
            </h2>
            <h2 class="m-0 md-headline text-white text-uppercase d-inline-block d-lg-none font-weight-bolder">
              Conheça nossos serviços empresariais e aumente a
              produtividade da sua equipe.
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="back row">
      <div class="bg-sob-back"></div>
      <img class="img-bg" src="../assets/background/bg_tech_man.jpg" alt="Apontando a tecnologia">
    </div>
  </div>

</template>

<script>
  export default {
    name: 'EmpresarialSection'
  }
</script>

<style scoped lang="scss">

  .empresarial {
    height: 400px;
    max-height: 400px;
    display: flex;
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .front {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%,rgba(0,0,0,0.75) 82%, rgba(0,0,0,0.65) 100%);
    display: flex;
    align-items: center;
  }

  .back {
    display: flex;
    min-width: 100%;
    position: absolute;
    z-index: 1;
  }

  .img-bg{
    /*width: 100%;*/
    min-width: 100%;
    width: 100%;
    object-fit: cover;
  }

  .bg-sob-back {
    min-width: 100%;
    width: 100%;
    display: flex;
    position: absolute;
    height: 100%;
  }

  .sombra-container {
    filter: drop-shadow(3px 3px 4px rgba(0, 0, 0, 0.75));
  }
</style>
